export enum SeatStatus {
  BOOKED = 'booked',
  CANCELED = 'canceled',
}

export interface UpdateSeatStatusPayload {
  is_enabled: boolean;
}

export interface ReservationCancellationPayload {
  reservation: string;
}

interface SeatStatusPayload {
  seat?: string;
  price?: string;
  pax?: number;
  features?: string;
  reservation_details?: SeatReservationStatusPayload;
}
interface SeatReservationStatusPayload {
  fullname: string;
  email?: string;
  phone_number?: string;
  remarks?: string;
  status?: SeatStatus;
  id?: string;
}

export default SeatStatusPayload;
